<template>
    <btn @click.native="toggle()"
        :loading="loading"
        :disabled="loading || isArchived == null"
        class="w-full text-center btn--primary"
    >{{ title }}</btn>
</template>

<script>
export default {

    props: {
        endpoint: {
            required: true
        },
        archived: {
            default: false
        }
    },

    data() {
        return {
            isArchived: this.archived,
            loading: false
        }
    },

    computed: {
        title() {
            return this.isArchived
                ? 'Obnovit z archivu'
                : 'Archivovat konverzaci';
        }
    },

    methods: {

        toggle() {
            this.loading = true;
            axios.patch(url(this.endpoint))

                .then(result => {
                    this.isArchived = result.data.archived;
                    this.loading = false;
                    Notify.info(this.isArchived ? 'Konverzace byla přesunuta do Archivu' : 'Konverzace byla obnovena z Archivu');
                })

                .catch(error => {
                    this.loading = false;
                    if (error.response.status === 403) {
                        Notify.error('Nemáte oprávnění');
                        return;
                    }
                    console.log(error);
                    alert('unexpected error');
                })
        },
    }
}
</script>
